package com.klantenstop.web.pages.authentication.registration

import com.klantenstop.web.auth.AuthModule
import com.klantenstop.web.data.models.dto.requests.user.InsertNewUser
import com.klantenstop.web.data.repos.UserRepo
import com.klantenstop.web.utils.AnalyticsManager
import com.materialkobweb.components.toast.ToastManager
import com.materialkobweb.utils.ViewModel
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class RegistrationViewModel(
    private val userRepo: UserRepo = UserRepo
) : ViewModel(), RegistrationContract {

    private val _state = MutableStateFlow(RegistrationContract.State())
    override val state = _state.asStateFlow()

    private val _effect = MutableSharedFlow<RegistrationContract.Effect>()
    override val effect = _effect.asSharedFlow()

    override fun sendIntent(intent: RegistrationContract.Intent) = coroutineScope.launch {
        when (intent) {
            is RegistrationContract.Intent.UpdateFormData -> updateState { it.copy(formData = intent.formData) }
            is RegistrationContract.Intent.Registration -> register()
        }
    }

    private suspend fun register() {
        updateState { it.copy(showValidation = true) }

        val formData = _state.value.formData

        if (formData == null) {
            ToastManager.warning("Vul alle velden in", title = "Ongeldige invoer")
            return
        }

        val firstName = formData.firstName
        val lastName = formData.lastName
        val email = formData.emailAddress
        val password = formData.password

        val insertNewUser = InsertNewUser(
            firstName = firstName,
            lastName = lastName,
            email = email,
            password = password,
            repeatPassword = password
        )

        if (!insertNewUser.isValid) {
            ToastManager.warning("Vul alle verplichte velden correct in", title = "Ongeldige invoer")
            return
        }

        try {
            userRepo.createUser(user = insertNewUser)

            // After successful registration, log the user in automatically
            val authState = AuthModule.login(email, password)
            check(authState.authenticated) { "Inloggen gelukt, maar sessie kon niet worden gevalideerd." }

            ToastManager.success("Account succesvol aangemaakt! Welkom ${insertNewUser.firstName}!", title = "Gelukt")
            AnalyticsManager.trackEvent(AnalyticsManager.Events.REGISTER_COMPLETED)
            emitEffect(RegistrationContract.Effect.NavigateToNextScreen)
        } catch (e: Exception) {
            ToastManager.error(e.message ?: "Er is een fout opgetreden bij het registreren", title = "Registratie mislukt")
        }
    }

    override fun emitEffect(effect: RegistrationContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (RegistrationContract.State) -> RegistrationContract.State) {
        _state.update(block)
    }
}
